import ReactDOM from 'react-dom';
import ConstValues from 'utils/const';

export function distanceBetweenElementAndBottomOfWindow(element) {
  // @ts-ignore Unsure why this works, maybe it doesn't
  const offset = ReactDOM.findDOMNode(element)?.offsetTop;
  return window.innerHeight + window.scrollY - offset - ConstValues.reactSelectize.fieldHeight;
}
